export default function zipToArrayBuffer (file) {
  return new Promise(function (resolve, reject) {
    const reader = new FileReader()
    // 読み込んだファイルの中身を取得する
    reader.readAsArrayBuffer(file)

    // ファイルの中身を取得後に処理を行う
    reader.addEventListener('load', function () {
      const arrayBuffer = reader.result
      const bytes = new Uint8Array(arrayBuffer)
      resolve(bytes)
    })
  })
}
